export const initialState = {
    loader: false,
    loaderLong: false,
    user:'',
    modalData: {
        position:false
    },
    languages:[],
    mainSliders:[],
    adminAbouts:[],
    aboutData:'',
    adminActivities:[],
    contents:[],
    donatesData:[],
    focusAreasData:[],
    projectsData:[],
    volunteeringData:[]
   
}
